import { render, staticRenderFns } from "./futong.vue?vue&type=template&id=2d43cd6a&scoped=true"
import script from "./futong.vue?vue&type=script&lang=js"
export * from "./futong.vue?vue&type=script&lang=js"
import style0 from "./futong.vue?vue&type=style&index=0&id=2d43cd6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d43cd6a",
  null
  
)

export default component.exports